import type { ComponentType, SVGProps } from 'react';
import { Box, Button, Flex, Icon, Text } from '@chakra-ui/react';

type Props = {
  icon: ComponentType<SVGProps<SVGSVGElement>>;
  iconBg?: string;
  iconColor?: string;
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
};

export default function CarouselEmptyState({
  icon,
  iconBg = 'brand.50',
  iconColor = 'brand.solid',
  title,
  description,
  actionLabel,
  onAction,
}: Props) {
  return (
    <Flex
      direction='column'
      align='center'
      justify='center'
      gap={2}
      py={6}
      px={4}
      borderWidth='1px'
      borderStyle='dashed'
      borderColor='gray.200'
      borderRadius='lg'
      bg='white'
      textAlign='center'
    >
      <Flex
        align='center'
        justify='center'
        w={9}
        h={9}
        borderRadius='full'
        bg={iconBg}
      >
        <Icon as={icon} w={4} h={4} color={iconColor} />
      </Flex>
      <Box>
        <Text fontSize='sm' fontWeight='semibold' color='gray.900'>
          {title}
        </Text>
        <Text fontSize='xs' color='gray.500' mt={0.5} maxW='sm' mx='auto'>
          {description}
        </Text>
      </Box>
      {actionLabel && onAction && (
        <Button
          size='xs'
          variant='outline'
          colorPalette='brand'
          borderRadius='full'
          onClick={onAction}
        >
          {actionLabel}
        </Button>
      )}
    </Flex>
  );
}
